import { ChatContentType } from '../../ChatDSTemplate/type';

/**
 * 根据会话 ID 和报告组件类型生成 Agent Chat 页面的 URL
 * @param sessionId 会话 ID
 * @param componentType 报告组件类型（可选）
 * @param isCosTag 是否来源于正文 <cos> 标签（cos 标签 xlsx 应保持 splitView 只读预览，与真正表格 ai_excel_file 区分）
 * @returns 生成的 URL 路径
 */
export function getAgentChatUrl(sessionId: string, componentType?: string, isCosTag?: boolean): string {
  const templateMap: Record<string, string> = {
    [ChatContentType.SmartTable]: 'aiExcel',
    [ChatContentType.MagicPoster]: 'magicPoster',
    [ChatContentType.Document]: 'dsReport',
    [ChatContentType.AiGallery]: 'splitView',
  };

  // cos 标签来源的智能表格：跳转后保持 splitView 只读预览，而非 aiExcel 工作区
  const template = isCosTag && componentType === ChatContentType.SmartTable
    ? 'splitView'
    : (componentType ? templateMap[componentType] : undefined);

  return template
    ? `/agent/chat?sessionId=${sessionId}&template=${template}`
    : `/agent/chat?sessionId=${sessionId}`;
}
